<div class="container" [ngClass]="background">
  <div class="container-content">
    {{ content | uppercase }}
  </div>
</div>
